import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <header className="privacy-page__banner">
                <div className="privacy-page__banner-inner">
                    <h1 className="privacy-page__title">Privacy Policy</h1>
                    <p className="privacy-page__subtitle">Last updated: 2024</p>
                </div>
            </header>

            <main className="privacy-page__outer">
                <article className="privacy-page__card">
                    <p className="privacy-page__intro">
                    This policy explains how Star123 uses and protects your information when you use our platform.                    </p>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">1 - Overview:</h3>
                        <p className="privacy-section__body">
                        At Star123, we respect your privacy and take your data seriously. This policy explains what information we collect, how we use it, and how we keep it protected. By using our services, you agree to these terms.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">2 - Use of Cookies:</h3>
                        <p className="privacy-section__body">
                        We use cookies to improve your experience on our platform. These are small files saved on your device that help remember your settings and make the website work better. You can turn off cookies in your browser, but some parts of the site may not work properly.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">3 - Data We Collect:</h3>
                        <p className="privacy-section__body">
                        We collect basic technical details automatically, such as your IP address, browser type, device information, pages you visit, and time of access. This helps us improve performance and fix technical problems.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">4 - Account Information:</h3>
                        <p className="privacy-section__body">
                        When you create an account, we collect details like your name, email, and contact number. This information is kept secure and is not shared or sold to unauthorized parties.                        </p>
                        <p className="privacy-section__body mb-2">We use your information to::</p>
                        <ul className="privacy-section__list">
                            <li>Send important notifications</li>
                            <li>Improve our services</li>
                            <li>Provide customer support</li>
                            <li>Inform you about updates</li>
                        </ul>
                        <p className="privacy-section__body mb-0">
                        Your password is private, and we will never ask you to share it.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">5 - When We Share Data:</h3>
                        <p className="privacy-section__body mb-2">
                        We do not sell your personal information. We may only share it in these situations:                        </p>
                        <ul className="privacy-section__list">
                            <li>With trusted service partners under strict privacy rules</li>
                            <li>If required by law or legal authorities</li>
                            <li>To detect or prevent fraud and misuse</li>
                            <li>If the business is transferred or merged with another company</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">6 - Data Security:</h3>
                        <p className="privacy-section__body">
                        We use strong security measures to keep your data safe from unauthorized access or misuse. While no system is completely secure, we do our best to protect your information.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">7 - Data Storage Duration:</h3>
                        <p className="privacy-section__body">
                        We keep your data only for as long as needed to provide our services or meet legal requirements. You can request account deletion anytime.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">8 - Third Party Links:</h3>
                        <p className="privacy-section__body">
                        Our platform may include links to other websites. We are not responsible for their privacy practices. Please check their policies before sharing your information.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">9 - Age Limit:</h3>
                        <p className="privacy-section__body">
                        Our services are not intended for users under 18 years old. If we find such data, it will be removed immediately.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">10 - Policy Updates:</h3>
                        <p className="privacy-section__body">
                        We may update this policy at any time. Changes will be effective immediately after posting. Please review it regularly.                        </p>
                    </section>

                    <section className="privacy-section">
                        <h3 className="privacy-section__heading">11 - Acceptance:</h3>
                        <p className="privacy-section__body">
                        By continuing to use Star123, you agree to this policy and how your data is handled.                        </p>
                    </section>

                    <section className="privacy-section mb-0">
                        <h3 className="privacy-section__heading">12 - Contact Us:</h3>
                        <p className="privacy-section__body mb-0">
                        If you have any questions, please contact our support team through the official website.               
         </p>
                    </section>
                </article>
            </main>
        </div>
    )
}

export default PrivacyPolicy
